import posthog from 'posthog-js';

let initialized = false;

export function initPostHog() {
  if (initialized) return posthog;

  const key = process.env.POSTHOG_KEY;
  const host = process.env.POSTHOG_HOST;

  if (!key || !host) {
    // eslint-disable-next-line no-console
    console.warn('[PostHog] Missing key/host; PostHog disabled.');
    return posthog;
  }

  posthog.init(key, {
    api_host: host,
    autocapture: false,
    capture_pageview: false,
    debug: true,
    persistence: 'localStorage+cookie',
  });

  initialized = true;
  return posthog;
}

export { posthog };
